import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Account from "../components/user/Account";

const Useraccountsettings = () => {
  return (
    <>
      <Navbar />
      <Account />
      <Footer />
    </>
  );
};

export default Useraccountsettings;
